import type { CoreProviderConfig } from '@openx/components-core/utils/context/CoreContext.tsx';
import { requireDefaults } from '@openx/components-core/utils/context/requiredDefaults.tsx';
import { useHistoryFetch } from './utils/useHistoryFetch.tsx';

export const coreConfig: CoreProviderConfig = {
  ...requireDefaults,
  useHistoryFetch,
};
